import {Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import {ConnectedPosition} from "@angular/cdk/overlay";
import {Subscription} from 'rxjs';
import {PopoverService} from "../../services/popover.service";

@Component({
    selector: 'app-custom-popover',
    templateUrl: './custom-popover.component.html',
    styleUrl: './custom-popover.component.scss'
})
export class CustomPopoverComponent implements OnInit, OnDestroy {
    @Input() index: any;
    @Input() title: string | undefined;
    @Input() content: string | undefined;
    @Input() noContentMessage: string | undefined;
    @Input() icon: string = 'total-info';
    @Input() tooltip: string = 'pages.inspectionItem.notes';

    openPopover: boolean = false;
    private uniqueId: string = '';
    private subscription: Subscription = new Subscription();

    popoverPositions: ConnectedPosition[] = [
        {
            originX: 'center', originY: 'top',
            overlayX: 'center', overlayY: 'bottom'
        },
        {
            originX: 'center', originY: 'bottom',
            overlayX: 'center', overlayY: 'top'
        }
    ];

    constructor(private popoverService: PopoverService) {
    }

    ngOnInit(): void {
        // Générer un ID vraiment unique pour ce popover instance
        this.uniqueId = `popover-${this.index}-${Math.random().toString(36).substring(2, 9)}`;

        // Écouter quand un popover est ouvert
        this.subscription = this.popoverService.popoverOpened.subscribe(openedId => {
            // Si un autre popover a été ouvert, fermer celui-ci
            if (openedId !== this.uniqueId && this.openPopover) {
                this.openPopover = false;
            }
        });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    // Support de la touche Echap pour fermer le popover
    @HostListener('document:keydown.escape')
    onEscapePress(): void {
        if (this.openPopover) {
            this.openPopover = false;
        }
    }

    togglePopover(event: MouseEvent): void {
        event.stopPropagation(); // Empêcher la propagation de l'événement

        // Inverser l'état actuel
        this.openPopover = !this.openPopover;

        // Si nous venons d'ouvrir ce popover, notifier les autres
        if (this.openPopover) {
            this.popoverService.notifyPopoverOpened(this.uniqueId);
        }
    }
}
